import React from 'react';
import { useStore } from 'store';
import TemplateSettingsBar from '../is_meetingMessageOverview-section/template-settings-bar/templateSettingsBar';
import EventView from './event-view/eventView';
// import { CARD_NAME } from 'enums';
import styles from './meetingPortraitSection.module.scss';

interface iProps {
  className?: string;
}

function MainSection(props: iProps): JSX.Element {
  const { className } = props;
  const [state] = useStore();

  const { currentCard } = state.meetingOverviewFull || {};
  return (
    <div className={`${styles.calenderEventsMainSection} ${className}`}>
      <EventView />
      <TemplateSettingsBar cardNumber={currentCard} shortCard />
    </div>
  );
}

MainSection.defaultProps = {
  className: '',
};

export default MainSection;
